import { useApiQuery } from "app/modules/api-client";
import { useDisplayAdvertiserPublisherDataAndParams } from "app/pages/digital-marketing/ad-intelligence/common/hooks/useDisplayAdvertiserPublisherDataAndParams";
import type { ISortProps } from "app/pages/digital-marketing/ad-intelligence/common/utils/utils";
import DurationService, { BasicDurations } from "app/services/DurationService";

export const useTableRows = (
    selectedDomain: string,
    page: number,
    pageSize: number,
    search?: string,
    sort?: ISortProps,
) => {
    const params = useDisplayAdvertiserPublisherDataAndParams();
    const { from, to, isWindow } = DurationService.getDurationData(params.duration).forAPI;

    const { data, isLoading, isFetching, isError } = useApiQuery(
        {
            tag: "AdIntelligenceMarketingAssets",
            methodName: "adIntelligenceAdvertiserCampaignsDataList",
            options: {
                select: (response) => {
                    if (!response) {
                        return;
                    }
                    return {
                        totalCount: response.totalCount,
                        startDate: response.startDate,
                        isFromNewScraper: response.isFromNewScraper,
                        items: response.data?.map((item) => {
                            return {
                                campaignName: item.campaign,
                                landingPageLink: item.landingPageLink,
                                creativesCount: item.creativesCount,
                                activeDays: item.activeDays,
                                firstSeen: item.firstSeen,
                                lastSeen: item.lastSeen,
                                campaignId: item.campaignId,
                            };
                        }),
                    };
                },
            },
        },
        {
            country: params.country,
            key: [selectedDomain],
            from,
            to,
            page,
            pageSize,
            includeTerms: search,
            isWindow,
            ...(isWindow ? { latest: BasicDurations.LAST_TWENTY_EIGHT_DAYS } : {}),
            ...sort,
        },
    );

    return { data: !isError && data, isLoading: isLoading || isFetching, isError };
};
